'use strict';
import Vue from 'vue';
import VueResource from 'vue-resource';
import { currentPage } from './section-specific/brokersnexus/commons/helper-classes';
import Radio from './components/components.radio-button.vue';
import { DashboardSession } from './section-specific/brokersnexus/commons/registration-session';
__webpack_public_path__ = '/assets/build/js/';

global.eventHub = new Vue();
import jQuery from 'jquery';
global.jQuery = jQuery;
global.$ = global.jQuery;

// raven-js removed — migrated to @sentry/vue (see main-vue.js)

Vue.use(VueResource);

Vue.http.interceptors.push((request, next) => {
    request.url += (request.url.indexOf('?') > 0 ? '&' : '?') + 'cb=' + new Date().getTime();
    next();
});

// Raven.context(function () {
    if(!GlobalVue) {
        GlobalVue = new Vue({
            el: '#globalVue',
            mixins: [DashboardSession],
            data: function () {
                return {
                    thisPage: '',
                    isMobileMenuOpen: false,
                    isProfileMenuOpen: false,
                    isLangMenuOpen: false,
                    isLearnMenuOpen: false,
                    showSideMenuLang: false
                }
            },
            created: function () {            
                this.thisPage = currentPage.call(this);
            },
            methods: {
                globalClickEvent: function (e) {
                    this.isProfileMenuOpen = false;
                    this.isLangMenuOpen = false;
                    this.isLearnMenuOpen = false;
                    window.removeEventListener('click', this.globalClickEvent);
                },
                toggleLearnMenu: function () {
                    this.isLearnMenuOpen = !this.isLearnMenuOpen;
                    setTimeout(() => {
                        if (this.isLearnMenuOpen) {
                            window.addEventListener('click', this.globalClickEvent);
                        } else {
                            window.removeEventListener('click', this.globalClickEvent);
                        }
                    }, 50);
                },
                toggleMobileMenu: function(e) {
                    this.isMobileMenuOpen = !this.isMobileMenuOpen;
                    let $sideMenu =$('.c-Side-menu');
                    $sideMenu.toggleClass('c-Side-menu--open');
                },
                toggleMyProfile: function(e) {
                    this.isProfileMenuOpen = true;
                    setTimeout(() => {
                        if (this.isProfileMenuOpen) {
                            window.addEventListener('click', this.globalClickEvent);
                        } else {
                            window.removeEventListener('click', this.globalClickEvent);
                        }
                    }, 50);
                },
                toggleLang: function () {
                    this.isLangMenuOpen = true;
                    setTimeout(() => {
                        if (this.isLangMenuOpen) {
                            let $langCon = $("#lang-container");
                            let $langSwitch = $("#lang-switch");
                            let offsetRight = ($(window).width() - ($langSwitch.offset().left + $langSwitch.outerWidth()));                            
                            $langCon.css('right', offsetRight+'px');

                            window.addEventListener('click', this.globalClickEvent);
                        } else {
                            window.removeEventListener('click', this.globalClickEvent);
                        }
                    }, 50);
                },
                clearSession: function () {
                    sessionStorage.setItem("sentRequestInfoEmail", "");
                }
            }
        })
    }
// });

let dynamicVueComponent = function() {
    if (this.content) {
        return {
            template: this.content,
            data () {
                return {
                    pcfTraining: {
                        option: null,
                        error: false,
                        submitted: false
                    }
                }
            },
            components: {
                'v-radio': Radio
            },
            watch: {
                'pcfTraining.option' () {
                    this.pcfTraining.error = false;
                }
            },
            created () {
                const pciprefill = sessionStorage.getItem('pciprefill');
                if (pciprefill) {
                    this.pcfTraining.option = pciprefill;
                }
            },
            methods: {
                showOtherModal(url) {
                    this.$parent.getAppModal(url, 'Yes');
                },
                pciPrefill () {
                    this.pcfTraining.error = false;
                    this.pcfTraining.submitted = true;
                    if (this.pcfTraining.option) {
                        sessionStorage.setItem('pciprefill', this.pcfTraining.option);
                        this.$root.$emit('pciprefill', this.pcfTraining.option);
                    } else {
                        this.pcfTraining.error = true;
                    }
                }
            }
        }
    }
};

Vue.component('modal', {
    props: ['modal-url', 'size-prop', 'modal-address', 'app-modal', 'videomodal', 'api-modal', 'content-modal', 'modal-header'],
        template: '#modal-template',
    data: function () {
        return {
            content: `<div>${window.bnJS.contentIsLoading}</div>`,
            sizeInit: 'default',
            uspsAddress: {
                address1: '',
                address2: '',
                city: '',
                state: '',
                contact: '',
                country: 'USA'
            },
            uspsValidated: false,
            showDynamicComponent: true
        }
    },
    computed: {
        size: function () {
            var size = this.sizeProp !== null ? this.sizeProp : this.sizeInit;
            return size;
        },
        dynamicVueComponent
    },
    created: function () {
        if(!this.apiModal && !this.videomodal && !this.contentModal && !this.appModal) {
            this.content = `
            <div>
                <h3 class="c-Modal__heading">${window.bnJS.modalImages[this.modalUrl].title}</h3>
                <img class="c-Modal__image" src="${window.bnJS.modalImages[this.modalUrl].image}">
            </div>
            `;
        } else if(this.videomodal) {
            this.content = `
            <div class="c-Modal__video c-Modal__video--isolated">
                <div class="c-Modal__video-wrapper">
                    <iframe
                    src="${this.modalUrl}"
                    frameborder="0"
                    allowfullscreen></iframe>
                </div>
            </div>
            `;
        } else if (this.contentModal) {
            this.content = `
                <div>
                    <h3 class="c-Modal__heading">${window.bnJS.modalContent[this.modalUrl].title}</h3>
                    <p>${window.bnJS.modalContent[this.modalUrl].para}</p>
                </div>
                `;
        } else if (this.appModal) {
            var self = this;
            var address = self.modalAddress;
            var obj = new Object();
            obj.addrArray = [address.address1,address.address2,address.city,address.state,address.postalCode,address.contact];
            var jsonAddress=JSON.stringify(obj);

            if((self.modalUrl != '' || self.modalUrl != 'undefined') && (jsonAddress != '' || jsonAddress != 'undefined') ) {
                let requestURL = 'sample.brokersnexus.com';
                if (location.hostname === 'brokersnexustest.com') {
                    requestURL = 'test.insubuytest.com';
                }
                self.$http.post('https://' + requestURL + '/api/application/validate-address', jsonAddress)
                    .then(
                        function (response) {
                            if (response.status === 200) {
                                var validatedAddress = response.body.data.uspsAddress;

                                if(validatedAddress!='' || validatedAddress!=null){

                                    if(validatedAddress === 'exception'){
                                        var msg = 'We were unable to validate your mailing address with United States Postal Service. Please select the address that you entered in order to continue.';
                                        $("#lab_returnText").html('<p>' + msg + '</p>');
                                        this.uspsValidated = false;
                                    }else{
                                        this.uspsValidated = true;
                                        var dataArr = validatedAddress.split('|#|');
                                        if(dataArr.length>2){
                                            self.uspsAddress.address2 = dataArr[0];
                                            self.uspsAddress.address1 = dataArr[1];
                                            self.uspsAddress.city = dataArr[2];
                                            self.uspsAddress.state = dataArr[3];
                                            self.uspsAddress.postalCode = dataArr[4];
                                            self.uspsAddress.contact = dataArr[8];
                                            var errorType = dataArr[6] != '' ? dataArr[6] : dataArr[5] != '' ? dataArr[5] : '';
                                            if(errorType!='') {
                                                this.uspsValidated = false;

                                                if(errorType.indexOf("Address Not Found") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.addressNotFound + '</p>');
                                                } else if(errorType.indexOf("Invalid Zip Code") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.invalidZipCode + '</p>');
                                                } else if(errorType.indexOf("Invalid City") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.invalidCity + '</p>');
                                                } else if(errorType.indexOf("Invalid State Code") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.invalidState + '</p>');
                                                } else if(errorType.indexOf("Multiple addresses were found") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.multipleAddressFound + '</p>');
                                                } else if(errorType.indexOf("Default address: The address you entered was found") > -1) {
                                                    $("#lab_returnText").html('<p>' + window.addressValidation.defaultAddress + '</p>');
                                                } else{
                                                    $("#lab_returnText").html('<p>' + errorType + '</p>');
                                                }
                                            }
                                        }else if(dataArr.length==2){
                                            if(dataArr[0]!='') {
                                                $("#lab_description").html('<p>' + dataArr[0] + '</p>');
                                            }
                                        }else{
                                            if(dataArr[0]!='') {
                                                $("#lab_returnText").html('<p>' + dataArr[0] + '</p>');
                                            }
                                            if(dataArr[1]!='') {
                                                $("#lab_description").html('<p>' + dataArr[1] + '</p>');
                                            }
                                        }
                                    }

                                }
                            } else {
                                self.content = problemMsg;
                                self.showDynamicComponent = true;
                                this.uspsValidated = false;
                            }
                        },
                        function (response) {
                            self.content = problemMsg;
                            this.uspsValidated = false;
                        }
                    )
            } else {
                self.content = problemMsg;
            }
        } else {
            let modalUrl = `/guide/terms?section=${this.modalUrl}`
            this.$http.get(modalUrl)
                .then(response => {
                        if (response.status === 200) {
                            this.content = response.body;
                        } else {
                            this.content = '';
                        }
                    },
                    errResponse => {
                        this.content = problemMsg;
                    }
                )
        }
    },
    methods: {        
        returnAddress: function(event){
            event.preventDefault();
            this.$emit('show-return-address', this.uspsAddress, this.uspsValidated);
            $('#validate_now')?.focus()
        },
        isSameAddress: function(addr1, addr2) {
            const checkProps = ['address1', 'address2', 'city', 'state', 'postalCode'];
            for (let prop of checkProps) {
                if (addr1[prop] !== addr2[prop]) {
                    return false;
                }
            }
            return true;
        },
        existingAddress : function(event){
            event.preventDefault();
            if (this.uspsValidated) {
                this.uspsValidated = this.isSameAddress(this.modalAddress, this.uspsAddress);
            }
            this.$emit('choose-entered-addresss', this.uspsValidated);
            $('#validate_now')?.focus()
        },
        emitCancelValidateAddress: function() {
            this.$emit('close');
            $('#validate_now')?.focus()
        },
    }
})

export const MainVueOpts = {
	data: function () {
        return {
            globalErrors: [],
            affiliateId: window.bnJS.loaderVersion || 0,
            thisPage: '',
            showSideMenu: false,
            showSideMenuLang: false,
            // Education group in the dashboard side nav - its own flag so it opens
            // independently of Sales Tracker. It stays collapsed on every page,
            // including its own: the drawer is the whole screen on mobile and an
            // expanded group pushes Marketing Materials and the account rows below
            // the fold. Open it by tapping the group.
            showEducationMenu: false,
            isProfileMenuOpen: false,
            isLangMenuOpen: false,
            bodyPosition: 0,
            modalShown: false,
            modalUrl: '',
            modalAddress:'',
            appModal: false,
            videomodal: false,
            apiModal: false,
            contentModal: false,
            modalHeader: '',
            reqMethod: 'get'
        }
    },
    created: function () {

        this.thisPage = currentPage.call(this);

        if (this.thisPage ==='search-policies'||
            this.thisPage === 'sales-report' ||
            this.thisPage === 'production-report' ||
            this.thisPage === 'activity-report' ||
            this.thisPage === 'click-report' || 
            this.thisPage === 'earnings-report') {
            this.showSideMenu = true;
        }

        var self = this;
        $(document).keyup(function(e) {
            e.preventDefault();
            if (e.keyCode == 27) {
                self.hideModal();
            }
        });
        
        // $(document).ready(() => {
        //     $('#js-Modal-Main').click((e) => {
        //         if (e.target.id === "js-Modal-wrap") {
        //             this.hideModal();
        //         }
        //     });
        // });
    },
    mounted() {
        global.eventHub.$on('show-modal', this.showModal);
        global.eventHub.$on('req-method', (val) => {
            if (val) this.reqMethod = val;
        });
        this.$root.$on('pciprefill', (opt) => {
            this.hideModal();
            this.$root.$emit('pcisetoption', opt);
        });
    },
    methods: {
        setBackendErrors: function (errors) {
            this.globalErrors = [];
            if (errors.length) {
                this.globalErrors = errors;
            }
        },
        hideThisError: function (errorIndex) {
            this.globalErrors.splice(errorIndex, 1);
        },
        toggleMyProfile: function (){},
        toggleLang: function (){
            this.isLangMenuOpen = !this.isLangMenuOpen;
            setTimeout(() => {
                if (this.isLangMenuOpen) {
                    let $langCon = $("#lang-container");
                    let $langSwitch = $("#lang-switch");
                    let offsetRight = ($(window).width() - ($langSwitch.offset().left + $langSwitch.outerWidth()));                            
                    $langCon.css('right', offsetRight+'px');

                    window.addEventListener('click', this.globalClickEvent);
                } else {
                    window.removeEventListener('click', this.globalClickEvent);
                }
            }, 50);
        },
        showModal: function (url, modalType) {
            if (url) {
                this.apiModal =  modalType === 'api' ? true : false;
                this.videomodal =  modalType === 'video' ? true : false;
                this.contentModal = modalType === 'content' ? true : false;
                this.appModal = false;
    
                this.modalUrl = url;    
                this.modalShown = true;
                this.bodyPosition = $('body').scrollTop();
                $('body').addClass('is-Locked');                
            }          
            // setTimeout(function () {
            //     window.injectEmail();
            // }, 500);
        },
        hideModal: function () {            
            this.modalShown = false;
            this.reqMethod = 'get';
            this.appModal = false;
            $('body').removeClass('is-Locked');
            $('body').scrollTop(this.bodyPosition);
        },
        showAddressModal: function(url,address){
            if (url && address) {
                this.modalUrl = url;
                this.modalAddress = address;
                //this.modalShown = true;
                this.appModal = true;
                this.bodyPosition = $('body').scrollTop();
                $('body').addClass('is-Locked');
            }
        },
        hideAddressModal: function(){
            this.modalShown=false;
            this.appModal=false;
        },
        clearSession: function () {
            sessionStorage.setItem("sentRequestInfoEmail", "");
        }
    }
};

if(!MainVue){
    MainVue = Vue.extend(MainVueOpts);
}

// $(document).ready(function() {
//     const isPublicWebsite = window.bnJS.currentPage == 'Home' || window.bnJS.currentPage == 'FAQ' || window.bnJS.currentPage == 'ContactUs' || window.bnJS.currentPage == 'OmnisecureAPI' || window.bnJS.currentPage == 'CompetitorsComparison';
//     const isPublicDashboard = window.bnJS.currentPage == 'login' || window.bnJS.currentPage == 'administrator-login' ||  window.bnJS.currentPage == 'forgot-password' || window.bnJS.currentPage == 'reset-password';

//     if(isPublicWebsite || isPublicDashboard) {
//         $(document).on('copy', handleCopyCut);
//         $(document).on('cut', handleCopyCut);
//     }
// });

function handleCopyCut(e) {
    // Disable copy/cut except for clipboard js buttons
    if ($(e.target)[0].nodeName !== 'TEXTAREA') {
        var noCopyMessage = window && window.globalLanguage ? window.globalLanguage.noCopyMessage : `The copy and cut function is disabled. brokersnexus.com is copyright 2002-${new Date().getFullYear()}.`;
        if (typeof alert === 'function') {
            // Try to solve Firefox NS_ERROR_UNEXPECTED issue
            try {
                alert(noCopyMessage);    
            } catch (e) {}  
            
        }
        return false;
    }
}

export default MainVue;
